import { defineComponent as _defineComponent } from 'vue'
import {
    builderDemoImagesData,
    landingFloorplansData,
  } from "@/constants/landingData";
  import { Steps } from "@/enums/BuilderDemoSteps";
  import { computed } from "vue";
  import HouseParts from "@/components/landing/HouseParts.vue";
  import { landingHousePartsData } from "@/constants/landingData";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderDemoMenuSelection',
  props: {
    currentStep: {
      type: String,
      required: true,
    },
    selectedImages: {
      type: Object,
      required: true,
    },
    currentStepIndex: {
      type: Number,
      required: true,
    },
    currentOptions: {
      type: Array as () => Array<{ url: string }>,
      required: true,
    },
  },
  emits: ["changeOption"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;
  const menuSelectionLabels = [...Object.values(Steps)];
  const menuLabel = computed(() => menuSelectionLabels[props.currentStepIndex]);
  const onClickChangeOption = (data: string) => emits("changeOption", data);

  const getSelectedOptionClass = (optionUrl: string) => {
    const { facadeUrl, floorplanUrl, optionalStepUrl } = props.selectedImages;

    const isFacadeSelected = facadeUrl === optionUrl;
    const isFloorplanSelected = floorplanUrl === optionUrl;
    const isOptionalStepSelected = optionalStepUrl === optionUrl;

    return {
      selected:
        isFacadeSelected || isFloorplanSelected || isOptionalStepSelected,
    };
  };
  const isSelectDesignStep = computed(
    () => props.currentStep === Steps.SELECT_DESIGN
  );
  const isOptionalStep = computed(
    () => props.currentStep === Steps.OPTIONAL_STEP
  );

const __returned__ = { props, emits, menuSelectionLabels, menuLabel, onClickChangeOption, getSelectedOptionClass, isSelectDesignStep, isOptionalStep, get builderDemoImagesData() { return builderDemoImagesData }, get landingFloorplansData() { return landingFloorplansData }, get Steps() { return Steps }, computed, HouseParts, get landingHousePartsData() { return landingHousePartsData } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})